import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  AfterViewInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import Glide from '@glidejs/glide';

@Component({
  selector: 'app-trusted-global-leaders',
  templateUrl: './trusted-global-leaders.component.html',
  styleUrls: ['./trusted-global-leaders.component.scss']
})
export class TrustedGlobalLeadersComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() trustedPartnerTitle: string = 'Trusted by Global Leaders';
  @Input() sliderData: Array<{ imgSrc: string, altText: string }> = [];

  isBrowser = false;
  glideInstance: any;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  defaultSliderData: Array<{ imgSrc: string, altText: string, width?: number }> = [
    { imgSrc: "/assets/images/client_logos/alternet.png", altText: "alternet" },
    { imgSrc: "/assets/images/client_logos/j-j.png", altText: "johnsons n johnsons" },
    { imgSrc: "/assets/images/client_logos/PrincetonUniversity.png", altText: "Princeton University", width: 180 },
    { imgSrc: "/assets/images/client_logos/novartis.png", altText: "novartis" },
    { imgSrc: "/assets/images/client_logos/scholastic.png", altText: "scholastic" },
    { imgSrc: "/assets/images/client_logos/cigna.png", altText: "cigna" },
    { imgSrc: "/assets/images/cambridge.png", altText: "cambridge university", width: 180 },
    { imgSrc: "/assets/images/client_logos/sanchini.png", altText: "sanchini" },
    { imgSrc: "/assets/images/client_logos/merck.png", altText: "merck" },
    { imgSrc: "/assets/images/client_logos/evolution_editing.png", altText: "evolution_editing" },
    { imgSrc: "/assets/images/client_logos/HarvardMedicalSchool.png", altText: "Harvard Medical School", width: 180 },
    { imgSrc: "/assets/images/client_logos/StanfordUniversity.png", altText: "Stanford University", width: 180 },
    { imgSrc: "/assets/images/client_logos/HarperCollinsPublishers.png", altText: "Harper Collins Publishers" }
  ];
  

  ngOnInit() {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngAfterViewInit() {
    this.initSlider();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isBrowser && changes['sliderData'] && !changes['sliderData'].firstChange) {
      this.destroySlider();  // remove previous instance if any
      this.initSlider();     // reinitialize
    }
  }

  private initSlider() {
    setTimeout(() => {
      if (document && document.querySelector('#globalTrustedSlider')) {
        this.glideInstance = new Glide('#globalTrustedSlider', {
          type: 'carousel',
          perView: 5,
          autoplay: 3000,
          breakpoints: {
            1024: { perView: 5 },
            768: { perView: 4 },
            480: { perView: 2 }
          }
        });
        this.glideInstance.mount();
      }
    }, 0);
  }

  private destroySlider() {
    if (this.glideInstance) {
      this.glideInstance.destroy();
      this.glideInstance = null;
    }
  }
}
